import { CommonModule } from '@angular/common';
import { ConfigModule } from 'Angular/config/config.module';
import { SimpleDropdownModule } from 'Angular/features/components/dropdowns/simple-dropdown/simple-dropdown.module';
import { LoadingSymbolModule } from 'Angular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import { PaginationControlsModule } from 'Angular/features/components/pagination/pagination-controls/pagination-controls.module';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import * as i0 from "@angular/core";
export class FlattenedHoldingsTableModule {
}
FlattenedHoldingsTableModule.ɵfac = function FlattenedHoldingsTableModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FlattenedHoldingsTableModule)(); };
FlattenedHoldingsTableModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FlattenedHoldingsTableModule });
FlattenedHoldingsTableModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        ConfigModule,
        DisabledModule,
        FeatureNeededModule,
        IconModule,
        LoadingSymbolModule,
        ModalBaseModule,
        PaginationControlsModule,
        SimpleDropdownModule] });
